import { TransferClientError } from '@zapier/transfer-client';
import { Fetch, Params } from '../../shared/types';
import type { Sample, ActionType, Zap } from '../types';
import invoke from './invoke';

const MAX_SAMPLES = 100;

type RequestData = {
  selected_api: string;
  type_of: ActionType;
  action: string;
  authentication_id?: number;
  params?: Params;
  test_poll?: boolean;
  is_sampling?: boolean;
  zap_id?: Zap['id'];
};

export const getSamples = async (fetch: Fetch, data: RequestData) => {
  const { results, status, errors } = await invoke<Sample>(fetch, data);

  switch (status) {
    case 'success':
      return results!.slice(0, MAX_SAMPLES);
    case 'error':
      throw new TransferClientError(errors![0]);
    default:
      console.error(`Unhandled status '${status}' in getSamples()`);
      return [];
  }
};

export default getSamples;
